import React from "react";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import OnboardingRadio from "../parts/inputs/onboarding-radio";

class SignupParqView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
    };
  }

  componentDidMount() {
    document.querySelector('input[name="heartCondition"]').focus();
  }

  render() {
    const { onBack, handleParqInfo, handleFieldChange } = this.props;
    const {
      heartCondition,
      chestPain,
      pastMonthChestPain,
      dizzinesConsciousnessLoss,
      boneJointProblem,
      bloodPressurePrescription,
      reasonForNoPhysicalAct,
    } = this.props;
    const QUESTIONS = [
      {
        question:
          "Has your doctor ever said that you have a heart condition and that you should only do physical activity recommended by a doctor?",
        name: "heartCondition",
        value: heartCondition,
      },
      {
        question:
          "Do you feel pain in your chest when you do physical activity?",
        name: "chestPain",
        value: chestPain,
      },
      {
        question:
          "In the past month, have you had chest pain when you were not doing physical activity?",
        name: "pastMonthChestPain",
        value: pastMonthChestPain,
      },
      {
        question:
          "Do you lose your balance because of dizziness or do you ever lose consciousness?",
        name: "dizzinesConsciousnessLoss",
        value: dizzinesConsciousnessLoss,
      },
      {
        question:
          "Do you have a bone or joint problem that could be made worse by a change in your physical activity?",
        name: "boneJointProblem",
        value: boneJointProblem,
      },
      {
        question:
          "Is your doctor currently prescribing drugs (for example, water pills) for your blood pressure or heart condition?",
        name: "bloodPressurePrescription",
        value: bloodPressurePrescription,
      },
      {
        question:
          "Do you know of any other reason why you should not do physical activity?",
        name: "reasonForNoPhysicalAct",
        value: reasonForNoPhysicalAct,
      },
    ];

    const changeQuestionValue = (event, index) => {
      QUESTIONS[index].value = event.target.value;
      handleFieldChange(event);
    };

    const checkForm = (e) => {
      e.preventDefault();
      const emptyExists = QUESTIONS.find((el) => el.value === null);
      if (emptyExists)
        return this.setState((prevState) =>
          Object.assign({}, prevState, {
            error: "Please fill all the options",
          })
        );

      return handleParqInfo(e);
    };

    return (
      <LoginWrapper
        mainClass="Onboarding athlete full-w parq"
        left={
          <form method="POST" data-noreset>
            <section className="mobile-hidden">
              <BackArrowButton onBack={() => onBack(5)} />
              <h1>
                Take the Physical Activity Readiness Questionnaire (PAR-Q)
              </h1>
              <p>
                Being physically active is very safe for most people. Some
                people, however, should check with their doctors before they
                increase their current level of activity. The PAR-Q has been
                designed to identify the small number of adults for whom
                physical activity may be inappropriate or those who should have
                medical advice concerning the type of activity most suitable for
                them.
              </p>
            </section>
            <header className="only-show-mobile">
              <div>
                <BackArrowButton onBack={() => onBack(5)} />
                <div>
                  <h1>
                    Take the Physical Activity Readiness Questionnaire (PAR-Q)
                  </h1>
                </div>
              </div>
              <p>
                Being physically active is very safe for most people. Some
                people, however, should check with their doctors before they
                increase their current level of activity. The PAR-Q has been
                designed to identify the small number of adults for whom
                physical activity may be inappropriate or those who should have
                medical advice concerning the type of activity most suitable for
                them.
              </p>
            </header>

            <section>
              {QUESTIONS.map((el, index) => {
                return (
                  <OnboardingRadio
                    key={`${el.name}${index}`}
                    label={el.question}
                    name={el.name}
                    value={el.value}
                    options={[
                      {
                        value: "yes",
                        label: "Yes",
                      },
                      { value: "no", label: "No", defaultChecked: true },
                    ]}
                    onClick={(value) => {
                      changeQuestionValue(
                        { target: { name: el.name, value } },
                        index
                      );
                    }}
                  />
                );
              })}
              <p className="!text-[--danger] mt-4">{this.state.error}</p>
            </section>

            <button
              data-button-type="primary"
              sz="large"
              onClick={checkForm}
              className="!w-1/2 mobile-hidden"
            >
              Continue
            </button>
            <button
              data-button-type="primary"
              sz="large"
              onClick={checkForm}
              className="only-show-mobile"
            >
              Continue
            </button>
          </form>
        }
      />
    );
  }
}

export default SignupParqView;
